import React from 'react';

const AWS_Exam_Preparation = () => {
  return (
    <div>
      <h1>AWS_Exam_Preparation</h1>
      <p>This is the AWS_Exam_Preparation component.</p>
    </div>
  );
};

export default AWS_Exam_Preparation;
